import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-textcounter', 'remaining', 'Liko simbolių:');
Labels.set(
    'ui-textcounter',
    'invalid',
    'Tekstas per ilgas (nedaugiau %d simbolių).'
);
